import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _547c3f7f = () => interopDefault(import('..\\pages\\glossary.vue' /* webpackChunkName: "pages/glossary" */))
const _37982100 = () => interopDefault(import('..\\pages\\userguide.vue' /* webpackChunkName: "pages/userguide" */))
const _0296135b = () => interopDefault(import('..\\pages\\videotutorials.vue' /* webpackChunkName: "pages/videotutorials" */))
const _5bef1d41 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _288cd507 = () => interopDefault(import('..\\pages\\_compare.vue' /* webpackChunkName: "pages/_compare" */))
const _95a90024 = () => interopDefault(import('..\\pages\\compare\\index.vue' /* webpackChunkName: "pages/compare/index" */))
const _2f97dfdc = () => interopDefault(import('..\\pages\\compare\\results.vue' /* webpackChunkName: "pages/compare/results" */))
const _824ad81e = () => interopDefault(import('..\\pages\\_subpage.vue' /* webpackChunkName: "pages/_subpage" */))
const _2e836e88 = () => interopDefault(import('..\\pages\\_subpage\\altedprogressreport.vue' /* webpackChunkName: "pages/_subpage/altedprogressreport" */))
const _b29b30f8 = () => interopDefault(import('..\\pages\\_subpage\\climate.vue' /* webpackChunkName: "pages/_subpage/climate" */))
const _4cdae1f4 = () => interopDefault(import('..\\pages\\_subpage\\collegecareer.vue' /* webpackChunkName: "pages/_subpage/collegecareer" */))
const _74ca7e1f = () => interopDefault(import('..\\pages\\_subpage\\demographics.vue' /* webpackChunkName: "pages/_subpage/demographics" */))
const _991aca8a = () => interopDefault(import('..\\pages\\_subpage\\mathscience.vue' /* webpackChunkName: "pages/_subpage/mathscience" */))
const _3676b834 = () => interopDefault(import('..\\pages\\_subpage\\moreinfo.vue' /* webpackChunkName: "pages/_subpage/moreinfo" */))
const _96f465ac = () => interopDefault(import('..\\pages\\_subpage\\overview.vue' /* webpackChunkName: "pages/_subpage/overview" */))
const _0619b26b = () => interopDefault(import('..\\pages\\_subpage\\reading.vue' /* webpackChunkName: "pages/_subpage/reading" */))
const _4ff1ce34 = () => interopDefault(import('..\\pages\\_subpage\\spree.vue' /* webpackChunkName: "pages/_subpage/spree" */))
const _7c74b40a = () => interopDefault(import('..\\pages\\_subpage\\surveyresults.vue' /* webpackChunkName: "pages/_subpage/surveyresults" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/glossary",
    component: _547c3f7f,
    name: "glossary"
  }, {
    path: "/userguide",
    component: _37982100,
    name: "userguide"
  }, {
    path: "/videotutorials",
    component: _0296135b,
    name: "videotutorials"
  }, {
    path: "/",
    component: _5bef1d41,
    name: "index"
  }, {
    path: "/:compare",
    component: _288cd507,
    children: [{
      path: "",
      component: _95a90024,
      name: "compare"
    }, {
      path: "results",
      component: _2f97dfdc,
      name: "compare-results"
    }]
  }, {
    path: "/:subpage",
    component: _824ad81e,
    name: "subpage",
    children: [{
      path: "altedprogressreport",
      component: _2e836e88,
      name: "subpage-altedprogressreport"
    }, {
      path: "climate",
      component: _b29b30f8,
      name: "subpage-climate"
    }, {
      path: "collegecareer",
      component: _4cdae1f4,
      name: "subpage-collegecareer"
    }, {
      path: "demographics",
      component: _74ca7e1f,
      name: "subpage-demographics"
    }, {
      path: "mathscience",
      component: _991aca8a,
      name: "subpage-mathscience"
    }, {
      path: "moreinfo",
      component: _3676b834,
      name: "subpage-moreinfo"
    }, {
      path: "overview",
      component: _96f465ac,
      name: "subpage-overview"
    }, {
      path: "reading",
      component: _0619b26b,
      name: "subpage-reading"
    }, {
      path: "spree",
      component: _4ff1ce34,
      name: "subpage-spree"
    }, {
      path: "surveyresults",
      component: _7c74b40a,
      name: "subpage-surveyresults"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
